import { Button } from "@/components/ui/button";
import { useSheetStore } from "@/zustand/sheetStore";
import { useState } from "react";

const Transfer = () => {
  const [option, setOption] = useState<"card" | "wallet">("card");
  const { openSheet } = useSheetStore();

  return (
    <div className="mx-auto text-lg text-white">
      <p className="text-lg font-semibold">Transfer</p>
      <p className="text-sm font-light">
        Please select where you would like to transfer from your available
        balance to
      </p>
      <div className="mt-4 space-y-2.5">
        <div
          onClick={() => {
            setOption("card");
          }}
          className={`flex h-12 cursor-pointer items-center justify-between gap-4 rounded-lg px-2.5 py-2 text-sm ${option == "card" ? "bg-primary-500/60" : "border-border-neutral/40] border"}`}
        >
          <span>Transfer to card</span>
          <div
            className={`size-3 rounded-full border ${option === "card" ? "bg-primary-100 border-transparent" : "border-primary-100"}`}
          />
        </div>
        <div
          onClick={() => {
            setOption("wallet");
          }}
          className={`flex h-12 cursor-pointer items-center justify-between gap-4 rounded-lg px-2.5 py-2 text-sm ${option == "wallet" ? "bg-primary-500/60" : "border-border-neutral/40] border"}`}
        >
          <span>Transfer to wallet</span>
          <div
            className={`size-3 rounded-full border ${option === "wallet" ? "bg-primary-100 border-transparent" : "border-primary-100"}`}
          />
        </div>
      </div>
      <div className="mt-6">
        <Button
          onClick={() => {
            if (option === "card") openSheet("transfer2Card");
            else openSheet("transfer2Wallet");
          }}
          className="text-primary-500 bg-primary-100 hover:bg-primary-100-hover mx-auto h-11 w-full rounded-md"
        >
          Continue
        </Button>
      </div>
    </div>
  );
};

export default Transfer;
